
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.727 17H9v-1.5c0-1.933 2.686-3.5 6-3.5s6 1.567 6 3.5V17h-2.727","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12 7a3 3 0 106 0 3 3 0 00-6 0z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4 25.999a4.588 4.588 0 003.687-1.868 4.57 4.57 0 007.373 0 4.57 4.57 0 007.373 0 4.588 4.588 0 003.687 1.868M4 21.575a4.586 4.586 0 003.687-1.868 4.572 4.572 0 007.373 0 4.57 4.57 0 007.373 0 4.587 4.587 0 003.687 1.868","stroke":"currentColor","stroke-width":"1.475","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    